import req from '@sportninja/common/api/request'
import { useCallback, useState } from 'react'
// @ts-ignore
import { store } from '../store'
import { Country } from '../types/Country'

export type { Country }

/**
 * Sorts countries so US appears first, then Canada, then the rest.
 */
function sortCountriesWithPriority(list: Country[]): Country[] {
  return [...list].sort((a, b) => {
    if (a.iso_3166_2 === 'US') return -1
    if (b.iso_3166_2 === 'US') return 1
    if (a.iso_3166_2 === 'CA') return -1
    if (b.iso_3166_2 === 'CA') return 1
    return 0
  })
}

export const useCountries = () => {
  const [countries, setCountries] = useState<Country[]>([])
  const [loading, setLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  const fetchCountries = useCallback(async () => {
    setLoading(true)
    setError(null)
    try {
      // Read from Redux store (populated on app init) instead of calling API
      const reduxCountries = store?.getState()?.types?.countries

      if (reduxCountries && Object.keys(reduxCountries).length > 0) {
        const countriesArray: Country[] = Object.values(reduxCountries)
        setCountries(sortCountriesWithPriority(countriesArray))
        return
      }

      // Fallback to direct API call if Redux state is not yet populated
      const response = await req('/countries')
      setCountries(sortCountriesWithPriority(response))
    } catch (err) {
      setError(
        err instanceof Error
          ? err
          : new Error('An error occurred while fetching countries')
      )
    } finally {
      setLoading(false)
    }
  }, [])

  return {
    countries,
    loading,
    error,
    refetch: fetchCountries,
  }
}
